<template>
    <v-card>
        <div class="modal">
            <div class="modal-content" style="width: 100%;overflow-x: hidden;">
                <s-toolbar label="IMPRESIÓN DE ENTREGA" dark :color="'#BAB6B5'" close @close="$emit('close')" class=""
                    print @print="downloadPdf()"></s-toolbar>
                <vue-html2pdf :htmlToPdfOptions="htmlToPdfOptions" :show-layout="true" :float-layout="false"
                    :enable-download="false" :preview-modal="false" :filename="`${form.CONTAINER_N}.pdf`"
                    pdf-format="a4" pdf-orientation="portrait" pdf-content-width="100%" :manual-pagination="true"
                    :margin="1" @beforeDownload="beforeDownload($event)" :autoPaging="true" ref="html2Pdf">
                    <section slot="pdf-content">
                        <div v-for="(group, pageIndex) in groupedItems" :key="pageIndex" class="pdf-page">
                            <!-- Cabecera -->
                            <div style="width: 100%; padding: 0.75cm 1.5cm;box-sizing: border-box;">
                                <table style="width: 100%; border: none;">
                                    <tr>
                                        <td style="width: 30%; text-align: left;">
                                            <img src="../../../../public/static/logo_sp.png" alt="Logo" width="160px" />
                                        </td>
                                    </tr>
                                </table>

                                <table
                                    style="width: 100%; display: table; border-collapse: collapse; border: 2px solid #000;">
                                    <tr>
                                        <td class="p-3 text-center font-semibold">PACKING LIST</td>
                                        <td class="p-3 text-center font-semibold border" style="width: 180px;">
                                            {{ form.DOCNUM }}
                                        </td>
                                        <td class="p-3 text-center font-semibold"
                                            style="font-size: 0.650rem;width: 90px;">
                                            CODIGO: <br>
                                            **-**-**** <br>
                                            VERSION: **
                                        </td>
                                    </tr>
                                </table>

                                <table
                                    style="width: 100%; display: table; border-collapse: collapse; border: none; font-size: 0.650rem;margin-top: 5px;color: #000;">
                                    <tr>
                                        <td class="p-3 font-semibold" style="width: 90px;">
                                            DATE
                                        </td>
                                        <td class="p-3" style="">
                                            : &nbsp;&nbsp; {{ form.DATE }}
                                        </td>
                                        <td class="p-3 font-semibold" style="width: 140px;">
                                            CONTAINER Nº
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.CONTAINER_N }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            CUSTOMER
                                        </td>
                                        <td class="p-3" style="">
                                            : &nbsp;&nbsp; {{ form.CUSTOMER }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            QUANTITY
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.QUANTITY.toLocaleString("en-US") }}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; BOXES
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            COMMODITY
                                        </td>
                                        <td class="p-3 text-uppercase" style="">
                                            : &nbsp;&nbsp; {{ form.COMMODITY }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            NET WEIGHT
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.NET_WEIGHT.toLocaleString("en-US") }}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Kg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            VARIETY
                                        </td>
                                        <td class="p-3" style="text-transform: uppercase;">
                                            : &nbsp;&nbsp; {{ form.VARIETY }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            GROSS WEIGHT
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.GROSS_WEIGHT.toLocaleString("en-US") }}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Kg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            BRAND
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; {{ form.MARK }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            TEMPERATURE
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.TEMPERATURE }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            BOOKING
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; {{ form.BOOKING }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            TEMPERATURE RECORDER N°
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.TERMOREGISTER_N }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            SHIPPING LINE
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; {{ form.SHIPPING_LINE }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            CUSTOMS SEAL
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.CUSTOMS_SEAL }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            VESSEL & VOYAGE
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; {{ form.VESSEL_VOYAGE }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            SHIPPING LINE SEAL
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.SHIPPING_LINE_SEAL }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            POD
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; {{ form.POD }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            SENASA/APHIS SEAL
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.SENASA_APHIS_SEAL }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            ETD
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; {{ form.ETD }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            SUNSHINE SEALS
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.SUNSHINE_SEALS }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            ETA
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; {{ form.ETA }}
                                        </td>
                                        <td class="p-3 font-semibold">
                                            STICKERS
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; {{ form.STICKERS }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-3 font-semibold">
                                            ORIGIN
                                        </td>
                                        <td class="p-3">
                                            : &nbsp;&nbsp; ****
                                        </td>
                                        <td class="p-3 font-semibold">
                                            PO N°
                                        </td>
                                        <td class="p-3" style="width: 180px;">
                                            : &nbsp;&nbsp; ****
                                        </td>
                                    </tr>
                                </table>

                                <table
                                    style="width: 100%; display: table; border-collapse: collapse; border: none;margin-top: 30px;">
                                    <tr>
                                        <td class="p-1 font-semibold text-xs text-center">
                                            DISTRIBUTION OF PALLETS IN CONTAINER
                                        </td>
                                    </tr>
                                </table>


                                <table class="text-9" v-for="(chunkt, rowIndex) in group"
                                    style="width: 100%; display: table; border-collapse: separate; border: none;margin-bottom: 5px;">
                                    <tr>
                                        <td v-for="(table, colIndex) in chunkt" :key="colIndex"
                                            :class="colIndex == 0 ? 'pr-5' : 'pl-5'"
                                            style="width: 50%;vertical-align: top;">
                                            <table
                                                style="display: table; border-collapse: collapse; border: 2px solid #000;">
                                                <tr style="background-color: #eee;">
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 35px;">
                                                        PALLET N°
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 40px;">
                                                        PACKING
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 40px;">
                                                        HARVEST DATE
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center">
                                                        VARIETY
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 25px;">
                                                        SIZE
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 40px;">
                                                        PIECES/BOX
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 60px">
                                                        GROWER AREA
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 45px;">
                                                        QUANTITY
                                                    </td>
                                                    <td class="p-1 border font-semibold text-center"
                                                        style="width: 60px;">
                                                        BOX BRAND
                                                    </td>
                                                </tr>
                                                <tr v-for="(row, rowIndex) in table" :key="rowIndex">
                                                    <td class="text-center border p-2">
                                                        {{ row.PltID }}-{{ row.PALLET_DIST }}
                                                    </td>
                                                    <td class="text-center border p-2">{{ row.DATE_DIST }}</td>
                                                    <td class="text-center border p-2">{{ row.HARVEST_DATE }}</td>
                                                    <td class="text-center border p-2"
                                                        style="text-transform: uppercase;">
                                                        {{ row.VARIETY_DIST }}
                                                    </td>
                                                    <td class="text-center border p-2">{{ row.SIZE_DIST }}</td>
                                                    <td class="text-center border p-2">{{ row.PldFruitxBoxe }}</td>
                                                    <td class="text-center border p-2">{{ row.GROWER_DIST }}</td>
                                                    <td class="text-center border p-2">{{ row.QUANTITY_DIST }}</td>
                                                    <td class="text-center border p-2"
                                                        style="text-transform: uppercase;">
                                                        {{ row.MARK_DIST }}
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>


                                <table class="text-9 mb-2" v-for="(chunkt, rowIndex) in chunk(form.DeliverySummary, 2)"
                                    style="width: 100%; display: table; border-collapse: separate; border: none;">
                                    <tr>
                                        <td v-for="(table, colIndex) in chunkt" :key="colIndex" :class="[
                                            colIndex === 0 ? 'pr-1' : 'pl-1',
                                        ]" style="width: 50%;vertical-align: top;">

                                            <table class="text-10" :class="chunkt.length == 1 ? ' w-50' : ' w-full'"
                                                style="display: table; border-collapse: collapse; border: 2px solid #000;">
                                                <tr>
                                                    <td class="border text-center font-semibold p-3"
                                                        style="background-color: #eee;" colspan="3">
                                                        {{ table.SUMMARY }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3" rowspan="2">
                                                        SIZE</td>
                                                    <td class="border text-center font-semibold p-3">QUANTITY</td>
                                                    <td class="border text-center font-semibold p-3" rowspan="2">
                                                        TOTAL</td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3"
                                                        style="text-transform: uppercase;">
                                                        {{ form.VARIETY }}
                                                    </td>
                                                </tr>
                                                <tr v-for="(detail, c) in table.DeliveryDetails" :key="c">
                                                    <td class="border text-center p-3">
                                                        {{ detail.cNumCalibre }}</td>
                                                    <td class="border text-center p-3">
                                                        {{ detail.QUANTITY.toLocaleString('en-US') }}
                                                    </td>
                                                    <td class="border text-center font-semibold p-3">
                                                        {{ detail.QUANTITY.toLocaleString('en-US') }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3">TOTAL</td>
                                                    <td class="border text-center font-semibold p-3">
                                                        {{table.DeliveryDetails.reduce((total, detail) => total +
                                                            detail.QUANTITY, 0)}}
                                                    </td>
                                                    <td class="border text-center font-semibold p-3">
                                                        {{table.DeliveryDetails.reduce((total, detail) => total +
                                                            detail.QUANTITY, 0)}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>

                                <table
                                    style="width: 100%; display: table; border-collapse: separate; border: none;margin-top: 50px;">
                                    <tr>
                                        <td class="pr-1" style="vertical-align: top; width: 50%;">
                                            <table class="text-10"
                                                style="width: 100%; display: table; border-collapse: collapse; border: 2px solid #000;">
                                                <tr>
                                                    <td class="border text-center font-semibold p-3" colspan="3">
                                                        CONTAINER PARAMETERS
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3">TEMPERATURE</td>
                                                    <td class="border text-center">
                                                        {{ form.TEMPERATURE }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold text-uppercase p-3">
                                                        HUMIDITY (%)
                                                    </td>
                                                    <td class="border text-center p-3">{{ form.HUMIDITY }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3">
                                                        VENTILATION (CBM/CBH)
                                                    </td>
                                                    <td class="border text-center p-3">
                                                        {{ form.VENTILATION }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3">
                                                        CONTROLLED ATMOSPHERE
                                                    </td>
                                                    <td class="border text-center p-3">
                                                        {{ form.ATMOSPHERE }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3">
                                                        OXYGEN (% 02)
                                                    </td>
                                                    <td class="border text-center p-3">
                                                        {{ form.OXYGEN }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border text-center font-semibold p-3">
                                                        CARBON DIOXIDE (% CO2)
                                                    </td>
                                                    <td class="border text-center p-3">
                                                        {{ form.DIOXIDE }}
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>

                                        <td class="pl-1" style="vertical-align: top; width: 50%;">
                                            <table class="text-10"
                                                style="width: 100%; display: table; border-collapse: collapse;">
                                                <tr>
                                                    <td class="border text-center font-semibold">
                                                        <table class="text-10"
                                                            style="width: 100%; display: table; border-collapse: collapse;">
                                                            <tr>
                                                                <td class="border text-center font-semibold p-3"
                                                                    style="width: 60%;">
                                                                    QUANTITY OF FILTERS:
                                                                </td>
                                                                <td class="border text-center p-3">
                                                                    {{ form.U_SYP_FILTROS }}</td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <table class="text-10"
                                                            style="width: 100%; display: table; border-collapse: collapse; border: 2px solid #000;margin-top: 20px;">
                                                            <tr>
                                                                <td class="border text-center font-semibold text-uppercase p-3"
                                                                    style="width: 40%;">
                                                                    TEMPERATURE RECORDER N°
                                                                </td>
                                                                <td class="border text-center font-semibold p-3"
                                                                    style="width: 30%;">BRAND</td>
                                                                <td class="border text-center font-semibold p-3"
                                                                    style="width: 30%;">PALLET N°
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="border text-center p-3">
                                                                    {{ form.U_SUN_TERMO1 }}
                                                                </td>
                                                                <td class="border text-center p-3">
                                                                    {{ form.U_SUN_BRAND1 }}
                                                                </td>
                                                                <td class="border text-center p-1">
                                                                    {{ form.U_SUN_PALLET1 }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="border text-center p-3">
                                                                    {{ form.U_SUN_TERMO2 }}
                                                                </td>
                                                                <td class="border text-center p-3">
                                                                    {{ form.U_SUN_BRAND2 }}
                                                                </td>
                                                                <td class="border text-center p-3">
                                                                    {{ form.U_SUN_PALLET2 }}</td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>

                            </div>
                        </div>
                    </section>
                </vue-html2pdf>
            </div>
        </div>
    </v-card>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import _sHelper from "@/services/HelperService";

export default {
    name: "DeliveryIQFPDF",
    props: {
        form: {
            type: Object,
            default: null,
        }
    },
    components: {
        VueHtml2pdf
    },
    data() {
        return {
            items: [],
            htmlToPdfOptions: {
                filename: `${this.form.DocEntry}-${this.form.DocNum}.pdf`,
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'portrait'
                },
                html2canvas: {
                    useCORS: true,
                    scale: 9,
                },
            },
            headers: [
                { text: "Código Artículo", value: 'ArtCode' },
                { text: "Descripción", value: 'DerDescription' },
                { text: "Unidad de Medida", value: 'UnitMeasurement' },
                { text: "Cantidad", value: 'DerQuantity' },
                { text: "Centro de Costo", value: 'CceName' },
                { text: "Línea de Negocios", value: 'BslName' },
                { text: "Tipo Costo", value: 'TypeCostName' },
                { text: "Proyecto", value: 'PrjName' },
            ],
            groupedItems: [],
        }
    },
    methods: {
        chunk(array, size) {
            const result = [];
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size));
            }
            return result;
        },
        downloadPdf() {
            this.$refs.html2Pdf.generatePdf();
        },

        formatDate(date) {
            return this.$fun.formatDateTimeShort12HView(date)
                .replace("AM", "a.m.")
                .replace("PM", "p.m.")
        },
        groupItems(items, groupSize = 9) {
            const grouped = [];
            for (let i = 0; i < items.length; i += groupSize) {
                grouped.push(items.slice(i, i + groupSize));
            }
            return grouped;
        },
        beforeDownload({ html2pdf, options, pdfContent }) {
            console.log(`On Before PDF Generation`)
            this.htmlToPdfOptions.filename = `${this.form.CONTAINER_N}.pdf`;
            html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(10)
                    pdf.setTextColor(150)
                    pdf.text('Página ' + i + ' de ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                }
            }).save()
        },

        groupItemsDynamic(items, maxRowsPerPage = 9) {
            const grouped = [];
            let currentGroup = [];
            let rowCount = 0;

            items.forEach((item) => {
                currentGroup.push(item);
                rowCount++;

                if (rowCount === maxRowsPerPage) {
                    grouped.push(currentGroup);
                    currentGroup = [];
                    rowCount = 0;
                }
            });

            if (currentGroup.length > 0) {
                grouped.push(currentGroup);
            }

            return grouped;
        },
        formatCurrency(value) {
            if (value === null || value === undefined) return ''
            return new Intl.NumberFormat('es-PE', {
                style: 'currency',
                currency: 'PEN',
                minimumFractionDigits: 2
            }).format(value)
        }
    },
    created() {
        // console.log(this.form)
        const chuncks = this.chunk(this.form.DeliveryPallets, 11)
        const chuncksTables = this.chunk(chuncks, 2)
        // console.log({ chuncks })
        this.groupedItems = this.groupItemsDynamic(chuncksTables, 2)
        // console.log(this.groupedItems)
    },
}
</script>

<style>
.pdf-page {
    background: #fff;
    font-family: sans-serif;
    height: 297mm;
    /* Altura exacta de una página A4 */
    width: 210mm;
    /* Ancho de una página A4 */
    margin: 0 auto;
    position: relative;
    margin-bottom: 20px;
    /* Un margen extra entre páginas para evitar desbordamientos */

    page-break-inside: avoid;
    /* Evita que el div se divida entre páginas */
    width: 100%;
    height: 100%;
    /* Garantiza que cada div ocupe una página completa */
    min-width: 210mm;
}


.obs {
    width: 90%;
    margin: auto;
    font-size: 12px;
    page-break-inside: avoid;
    /* Evita divisiones en el contenido de observaciones */
}

.details-table thead {
    display: table-header-group;
}

.details-table tr {
    page-break-inside: avoid;

}

.details-table tbody tr {
    page-break-inside: avoid;
    margin-top: 10px;
}

.details-table {
    page-break-inside: auto;
}

.details-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
    margin-top: 10px;
    border-top: 4px double black;
    border-bottom: 4px double black;
}

.details-table th {
    border-bottom: 4px double black;
    text-align: center;
    padding: 8px;
}

.details-table td {
    text-align: center;
    padding: 8px;
}

.w-full {
    width: 100%;
}

.w-50 {
    width: 50%;
}

.p-1 {
    padding: 0.1rem;
}

.p-2 {
    padding: 0.2rem;
}

.p-3 {
    padding: 0.28rem;
}

.pr-1 {
    padding-right: 0.1rem;
}

.pl-1 {
    padding-left: 0.1rem;
}

.pl-2 {
    padding-left: 0.2rem;
}

.pr-2 {
    padding-right: 0.125rem;
}

.pl-4 {
    padding-left: 1rem;
}

.pl-5 {
    padding-left: 1.25rem;
}

.pr-4 {
    padding-right: 1rem;
}

.pr-5 {
    padding-right: 1.25rem;
}

.text-uppercase {
    text-transform: uppercase;
}

.font-semibold {
    font-weight: bold;
}

.text-sm {
    font-size: 0.875rem;
}

.text-xs {
    font-size: 0.725rem;
}

.text-10 {
    font-size: 0.625rem;
}

.text-9 {
    font-size: 0.525rem;
}

.text-8 {
    font-size: 0.425rem;
}

.text-center {
    text-align: center;
}

.border {
    border: 1px solid #000;
}

.modal {
    /* display: flex; */
    /* justify-content: center;
    align-items: center; */
    position: relative;
    /* top: 0;
    left: 0; */
    width: 100%;
    height: 100%;
    /* margin: auto; */
    background-color: rgba(0, 0, 0, 0.5);
    /* z-index: 1000; */
}


.modal-content {
    /* background-color: #fff; */
    /* padding: 20mm; */
    /* border: 1px solid #000; */
}
</style>